import {
  IActionDataModel,
  IAdaptiveActionCard,
  IQnACommentRequestPayload,
  IQnACommentResponseItem,
  IQnADetailPayload,
  IQnAListPayload,
  IQuestionAnswer,
} from '@ninjacart/nc-nk-core';
import { AxiosRequestConfig } from 'axios';
import { Buffer } from 'buffer';
import paths from '../path';
import { QnaKisanClient } from './qnaKisanClient';

export const getAllQnAList = async (
  config: IQnAListPayload
): Promise<IAdaptiveActionCard<IActionDataModel<IQuestionAnswer>>[]> => {
  try {
    console.log('All qna url => ', paths.getAllQuestionsApi(config));
    const response = await QnaKisanClient.get(paths.getAllQuestionsApi(config));
    return response.data?.data;
  } catch (e) {
    console.error('All QnA List Error', e);
    throw e;
  }
};

export const getAllQnADetail = async (
  config: IQnADetailPayload
): Promise<IQuestionAnswer> => {
  try {
    const response = await QnaKisanClient.get(paths.getPostDetailApi(config));
    return response.data;
  } catch (e) {
    console.error('QnA Detail Error', e);
    throw e;
  }
};

export const getUserQnAList = async (
  config: IQnAListPayload
): Promise<IAdaptiveActionCard<IActionDataModel<IQuestionAnswer>>[]> => {
  try {
    const axiosRequest: AxiosRequestConfig = {};
    axiosRequest.validateStatus = (status: number) => {
      return (status >= 200 && status < 309) || status === 404;
    };
    const response = await QnaKisanClient.get(paths.getQuestionsByUserApi(config), axiosRequest);
    if (response.status === 404) {
      return [];
    }

    return response.data?.data;
  } catch (e) {
    console.error('QnA User List Error', e);
    throw e;
  }
};

export const createCommentQnA = async (config): Promise<IQnACommentResponseItem> => {
  try {
    const response = await QnaKisanClient.post<IQnACommentResponseItem>(
      paths.createCommentQnAApi(config?.formData),
      config?.payload
    );
    console.log('QnA New Comment', JSON.stringify(response.data));
    return response.data;
  } catch (e) {
    console.error('QnA Create Comment Error', e);
    throw e;
  }
};

export const getQnACommentList = async (
  config: IQnACommentRequestPayload
): Promise<IQnACommentResponseItem[]> => {
  try {
    const response = await QnaKisanClient.get(paths.getAllCommentsAgainstPost(config));
    return response.data;
  } catch (e) {
    console.error('QnA Comment List Error', e);
    throw e;
  }
};

export const onQnAReplyLike = async (params: IQnADetailPayload) => {
  try {
    const response = await QnaKisanClient.put(paths.likeReply(params));
    return response.data;
  } catch (e) {
    console.error('QnA SearchList  Error', e);
    throw e;
  }
};

export const getImageInBase64 = async (url: string) => {
  try {
    const response = await QnaKisanClient.get(url, {
      responseType: 'arraybuffer',
    });
    const base64 = Buffer.from(response.data, 'binary').toString('base64');
    return base64;
  } catch (e) {
    console.error('QnA SearchList  Error', e);
    throw e;
  }
};
